document.addEventListener('DOMContentLoaded', function() {
    const videoWrappers = document.querySelectorAll('.video-wrapper');

    videoWrappers.forEach(function(videoWrapper) {
        const playVidButton = videoWrapper.querySelector('.play-video');

        playVidButton.addEventListener('click', function() {
            const videoURL = videoWrapper.getAttribute('data-video-url');
            const xhr = new XMLHttpRequest();
            xhr.open('POST', WPDATA.ajaxurl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

            xhr.onload = function() {
                if (xhr.status === 200) {
                    videoWrapper.innerHTML += xhr.responseText;
                    setTimeout(function() {
                        videoWrapper.classList.add('playing');
                    }, 500);
                } else {
                    videoWrapper.innerHTML = 'Error decoding base64 iframe. Please try again.';
                }
            };

            xhr.onerror = function() {
                console.error('Request failed');
                videoWrapper.innerHTML = 'Error: Request failed. Please try again.';
            };

            // Prepare data to send
            const data = 'action=iframe_ajax_handler&videoURL=' + encodeURIComponent(videoURL);
            xhr.send(data);
        });
    });
});

